// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@awc/XDL/types";
import { color } from "@awc/XDL/Utilities";
import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            size: 14,
            color: "common.ui3",
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 16px;
                max-width: 100%;
                word-wrap: break-word;
                &${IconWrapper}, &${IconWrapper} svg {
                    width: 6px;
                    height: 10px;
                    color: ${color("common.ui3")};
                }
            `,
        },
        css: css`
            flex-wrap: wrap;
            gap: 12px 8px;
        `,
    },
} as xBaseTheme["breadcrumbs"];
